/**
 * This code imports the configureStore function from the '@reduxjs/toolkit'
 * library and three reducers from separate files.
 * It then uses the configureStore function to create a Redux store with the three
 * reducers combined into a single root reducer.
 * The resulting store is exported as the default export of this module.
 */

import { configureStore } from '@reduxjs/toolkit'
import screensSlice from './reducers/screens'
import modelsSlice from './reducers/models'
import loaderSlice from './reducers/loader'

const store = configureStore({
  reducer: {
    screens: screensSlice,
    models: modelsSlice,
    loader: loaderSlice
  }
})

export default store
